import moment from 'moment-timezone';
import { Services } from '@gscope-mfe/app-bridge';

const { downloadErrorReport } = Services;

export const getNextCacheRefreshTime = (cacheBuildCount, cacheTimestamp) => {
    // Cache will not be created in bulkupload if the below two conditions are met
    if (!cacheTimestamp || cacheBuildCount >= 500) return null;

    const delayInMins = cacheBuildCount / 50 + 1 || 1;

    const lastCacheTime = moment(cacheTimestamp);
    const refreshTime = lastCacheTime.add(delayInMins * 60 + 30, 'seconds');

    if (moment().isAfter(refreshTime)) {
        return null;
    }

    return refreshTime;
};

export const downloadErrorWithOriginalRow = async (transactionId, ERRORED_DATA_FILE_NAME) => {
    const resFile = await downloadErrorReport(transactionId);
    const url = window.URL.createObjectURL(new Blob([resFile.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', ERRORED_DATA_FILE_NAME);
    link.download = ERRORED_DATA_FILE_NAME;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};

export const isExcelWorkbook = (filename) => {
    const excelPattern = /\.(xls|xlsx|xlsm|xlsb|xltx|xltm|xlt|xla|xlw|xlr|xml|xlam)$/i;
    return excelPattern.test(filename);
};
